import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { UpsertWorkflowRequest, WorkflowItem } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function upsertWorkflow(data: UpsertWorkflowRequest): Promise<WorkflowItem> {
  return api.post("/explorer/workflow", data)
}

export function useUpsertWorkflow() {
  const queryClient = useQueryClient()

  const upsertWorkflowMutation = useMutation({
    mutationKey: queryKeys.upsertWorkflow,
    mutationFn: (data: UpsertWorkflowRequest) => upsertWorkflow(data),
    onSuccess: async (workflow) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.workflows }),
        queryClient.invalidateQueries({ queryKey: queryKeys.workflow(workflow.id) }),
      ])
    },
  })

  return upsertWorkflowMutation
}
